import { render, staticRenderFns } from "./thirdTable.vue?vue&type=template&id=4aea11f7&scoped=true"
import script from "./thirdTable.vue?vue&type=script&lang=js"
export * from "./thirdTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4aea11f7",
  null
  
)

export default component.exports